import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./App.css"; // ← Capital A!
import { initSentry } from "./config/sentry";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import LoadingFallback from "./components/shared/LoadingFallback";

// Initialize Sentry error tracking before rendering
initSentry();

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h1>Something went wrong</h1>
          <p>We've been notified and are working on a fix.</p>
          <button onClick={() => window.location.reload()}>
            Refresh Page
          </button>
        </div>
      }
      onError={(error, componentStack) => {
        console.error("React Error Boundary caught:", error, componentStack);
      }}
    >
      {/* Top-level Suspense catches the i18next HTTP backend's initial
          translation fetch. Header lives outside App.js's route-level
          Suspense and uses useTranslation(), so it would otherwise
          suspend with no boundary to catch it. */}
      <Suspense fallback={<LoadingFallback />}>
        <App />
      </Suspense>
    </Sentry.ErrorBoundary>
  </StrictMode>
);

// Register service worker for PWA functionality (production only)
// In development, the service worker aggressively caches JS bundles
// and prevents hot-reload from working correctly
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      // Dispatch a custom event that ServiceWorkerUpdateBanner listens for.
      // The banner shows a styled in-app prompt; clicking Reload invokes the
      // callback below, which activates the waiting SW and reloads the page.
      window.dispatchEvent(
        new CustomEvent("cm:sw-update-available", {
          detail: {
            registration,
            reload: () => {
              serviceWorkerRegistration.skipWaiting();
              window.location.reload();
            },
          },
        })
      );
    },
  });
} else {
  serviceWorkerRegistration.unregister();
}
